import { render, staticRenderFns } from "./QuestionAndAnswer.vue?vue&type=template&id=1e0d8428"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e0d8428')) {
      api.createRecord('1e0d8428', component.options)
    } else {
      api.reload('1e0d8428', component.options)
    }
    module.hot.accept("./QuestionAndAnswer.vue?vue&type=template&id=1e0d8428", function () {
      api.rerender('1e0d8428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/content/QuestionAndAnswer.vue"
export default component.exports